import React, { memo } from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./ota-firmware-version-drawer-modal.module.scss";
import { Title } from "@src/components/atoms/title/title";
import { DrawerIconContainer } from "@src/components/atoms/drawer-icon-container/drawer-icon-container";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import FirmwareUploadIcon from "@src/assets/svg/firmware-upload.svg";
import firmwareIcon from "@src/assets/svg/firmware-icon-active.svg";

import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { Button } from "@src/components/atoms/buttons/button/button";
import { DrawerButtonWrapper } from "@src/components/molecules/drawer-button-wrapper/drawer-button-wrapper";
import { OtaDrawerDataInterface } from "@src/types/ota-update";
import { OtaDrawerForm } from "@src/components/molecules/ota-drawer-form/ota-drawer-form";
import OtaDrawerInfo from "@src/components/molecules/ota-drawer-info/ota-drawer-info";
import { OTA_FIRMWARE_VERSION_DRAWER_MODAL } from "@src/cloud-connect/ota-update/constants";
import { useOtaFirmwareVersionDrawerModal } from "./use-ota-firmware-version-drawer-modal";

const cssClassName = "ota-firmware-version-modal";
interface OtaFirmwareVersionDrawerModalProps {
  inputValues: OtaDrawerDataInterface;
  setInputValues: React.Dispatch<React.SetStateAction<OtaDrawerDataInterface>>;
}

export const OtaFirmwareVersionDrawerModal = memo(
  ({ inputValues, setInputValues }: OtaFirmwareVersionDrawerModalProps) => {
    const { texts, handleCloseDrawerModal, handleSubmit } =
      useOtaFirmwareVersionDrawerModal({
        inputValues,
        setInputValues,
      });

    return (
      <DrawerModal id={OTA_FIRMWARE_VERSION_DRAWER_MODAL}>
        <div className={styles[cssClassName]}>
          <FlexColumnContainer verticalGap={24}>
            <Title tag="h2" text={texts.releaseNewFirmwareText} />
            <DrawerIconContainer icon={FirmwareUploadIcon} />

            <div className={styles[`${cssClassName}__content-wrapper`]}>
              <FlexRowContainer horizontalGap={8}>
                <img
                  className={styles[`${cssClassName}__container-icon`]}
                  alt={"Firmware"}
                  src={firmwareIcon}
                />
                <p className={styles[`${cssClassName}__subtitle`]}>
                  {texts.releaseFirmwareDetailsText}
                </p>
              </FlexRowContainer>

              <div className={styles[`${cssClassName}__metadata-box`]}>
                <OtaDrawerInfo />
                <OtaDrawerForm
                  values={inputValues}
                  setValues={setInputValues}
                />
              </div>

              <DrawerButtonWrapper>
                <Button fun={handleSubmit} text={texts.releaseFirmwareText} />
                <Button
                  fun={handleCloseDrawerModal}
                  text={texts.cancelText}
                  variant={"secondary"}
                />
              </DrawerButtonWrapper>
            </div>
          </FlexColumnContainer>
        </div>
      </DrawerModal>
    );
  },
);

OtaFirmwareVersionDrawerModal.displayName = "OtaFirmwareVersionDrawerModal";
